var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect } from "react";
import { useBrand } from "@/contexts/cdpConfig";
import { fetchWithTimeout } from "@/utils";
const leadValueTransformer = (rawLeadValue) => {
    var _a;
    return ({
        qval: "" + ((_a = rawLeadValue.qval) !== null && _a !== void 0 ? _a : 0),
        qfact: "" + rawLeadValue.qfact,
        qval_cand: "" + rawLeadValue.qval_cand,
    });
};
const seekerLeadValuePath = "/seeker-lead-value";
export const useLeadValue = ({ crsBaseUrl, legacyId, shouldSendLeadValue, }) => {
    const [leadValue, setLeadValue] = useState(null);
    const brand = useBrand();
    useEffect(() => {
        const fetchLeadValue = () => __awaiter(void 0, void 0, void 0, function* () {
            if (shouldSendLeadValue && crsBaseUrl && legacyId && !leadValue) {
                const seekerLeadUrl = `${crsBaseUrl}${seekerLeadValuePath}/${legacyId}?brand=${brand}`;
                try {
                    yield fetchWithTimeout(seekerLeadUrl, {
                        method: "GET",
                        mode: "cors",
                        headers: {
                            Accept: "application/json",
                        },
                    })
                        .then((response) => response.json())
                        .then((data) => setLeadValue(leadValueTransformer(data)));
                }
                catch (error) {
                    console.error("fetchLeadValue: An error occurred while fetching.", error);
                }
            }
        });
        fetchLeadValue();
    }, [shouldSendLeadValue, crsBaseUrl, legacyId, leadValue, brand]);
    return leadValue;
};
